import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import fr from 'vuetify/es5/locale/fr'

Vue.use(Vuetify);

export default new Vuetify({
    lang: {
        locales: { fr },
        current: 'fr',
    },
    theme: {
        themes: {
            light: {
                primary: '#0a252c',
                secondary: '#ffc107',
                accent: '#03a9f4',
                error: '#2196f3',
                warning: '#673ab7',
                info: '#9c27b0',
                success: '#1e9c6e'
            },
        },
    },
});
